
const ShippingPolicy = () => {
  return (
    <>
      <div className=" bg-white overflow-hidden">
         <div className="w-screen h-64 md:h-[430px] border-[3px] border-[#35A93E]">
          <img
            src="/shipping.jpeg"
            alt="Shipping Banner"
            className="w-full h-full object-contain md:object-contain"
          />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 my-6">
          <div className="border-b border-gray-200 pb-6 mb-10">
            <h1 className="text-2xl font-bold text-gray-900">
              Shipping & Delivery Policy
            </h1>
            <p className="text-base text-gray-700 mt-4">
              This Shipping & Delivery Policy outlines how orders placed on
              LifeOnPlus are processed, dispatched, and delivered. It applies to
              physical products and, where applicable, sample kits, wellness
              devices, or other tangible goods ordered through the LifeOnPlus
              platform.
            </p>
          </div>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              1. Introduction
            </h2>
            <p className="text-base text-gray-700 leading-7">
              This Shipping & Delivery Policy outlines how orders placed on
              LifeOnPlus are processed, dispatched, and delivered. It applies to
              physical products and, where applicable, sample kits, wellness
              devices, or other tangible goods ordered through the LifeOnPlus
              platform.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              2. Delivery Coverage
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                LifeOnPlus delivers across most pin codes in India via trusted
                courier and logistics partners.
              </li>
              <li className="mb-2">
                For remote or non-serviceable locations, users will be notified
                at the time of order or checkout.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              3. Shipping Timelines
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                Standard delivery for most products is within 3-10 working days
                from the date of order confirmation.
              </li>
              <li className="mb-2">
                Delays may occur due to regional lockdowns, weather, courier
                constraints, or unforeseen circumstances.
              </li>
              <li className="mb-2">
                Express or priority shipping may be available for select items
                at additional cost.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              4. Order Processing
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                Orders are processed within 24–48 hours of payment confirmation,
                excluding weekends and public holidays.
              </li>
              <li className="mb-2">
                Users will receive order confirmation and tracking details via
                email or SMS once the order is dispatched.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              5. Shipping Charges
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                Shipping fees may vary based on product weight, location, or
                delivery speed.
              </li>
              <li className="mb-2">
                Free shipping may be offered on select items or during
                promotional campaigns.
              </li>
              <li className="mb-2">
                Final shipping charges will be displayed at checkout before
                payment.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              6. Tracking & Delivery
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                Orders can be tracked using the tracking number sent via SMS or
                email.
              </li>
              <li className="mb-2">
                Delivery will be attempted at the shipping address provided
                during checkout.
              </li>
              <li className="mb-2">
                If undelivered after 2-3 attempts, the order may be returned to
                the origin and additional charges may apply for re-shipping.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              7. Damaged or Missing Items
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                If a package is tampered, damaged, or items are missing,
                customers must notify LifeOnPlus within 48 hours of delivery.
              </li>
              <li className="mb-2">
                Replacement or refund requests will be processed only after
                verification and may require unboxing photos or courier
                acknowledgment.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              8. Non-Delivery
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                LifeOnPlus is not responsible for delivery failure due to
                incorrect address, unavailability, or refusal to accept.
              </li>
              <li className="mb-2">
                Such orders may not qualify for refund unless proven to be an
                error by the platform or logistics partner.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              9. International Shipping
            </h2>
            <p className="text-base text-gray-700 leading-7">
              Currently, LifeOnPlus does not offer international shipping.
              Services are limited to within the Republic of India.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              10. Contact Us
            </h2>
            <p className="text-base text-gray-700 leading-7">
              For shipping-related queries, contact:
            </p>
            <p className="text-base text-gray-700 leading-7 mt-3">
              Email:{" "}
              <a
                href="mailto:support@lifeonplus.com"
                className="text-blue-600 hover:underline"
              >
                support@lifeonplus.com
              </a>
              <br />
              Address: Lifeonplus Technologies India Private Limited, No.301,
              3rd Floor, “Master Mind 1, Royal Palms”, Aarey Milk Colony,
              Goregaon (East), Mumbai-400065
              <br />
              Contact: 📞{" "}
              <a
                href="tel:+919986880000"
                className="text-blue-600 hover:underline"
              >
                99868 80000
              </a>{" "}
              | ✉️{" "}
              <a
                href="mailto:info@lifeonplus.com"
                className="text-blue-600 hover:underline"
              >
                info@lifeonplus.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default ShippingPolicy;
